
<template>
  <div class="wrapper">
    <div class="icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        id="Capa_1"
        x="0px"
        y="0px"
        width="31.109px"
        height="31.109px"
        viewBox="0 0 31.109 31.109"
        style="enable-background:new 0 0 31.109 31.109; mix-blend-mode: multiply;"
        xml:space="preserve"
      >
        <path class="default" :class="quality" d="M0.459,31.109h5.289V20.051H0.459V31.109z" />
        <path class="default line2" :class="quality" d="M8.76,31.109h5.289V14.543H8.76V31.109z" />
        <path class="default line3" :class="quality" d="M17.062,31.109h5.285V6.171h-5.285V31.109z" />
        <path class="default line4" :class="quality" d="M30.65,0v31.109h-5.289V0H30.65z" />
        <g />
      </svg>
    </div>
    <div class="description">
      <span>{{$t(`point.${quality}`)}}</span>
      <br />
      <span>{{label}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "signalQuality",
  props: { rssi: { type: Number, default: -999 } },
  data() {
    return {
      quality: ""
    };
  },
  computed: {
    label() {
      return `${this.rssi.toFixed(2)} dBm`;
    }
  },
  created() {
    this.calculateQuality();
  },
  methods: {
    calculateQuality() {
      if (this.rssi >= -55) {
        this.quality = "excellent";
      } else if (this.rssi < -55 && this.rssi >= -65) {
        this.quality = "good";
      } else if (this.rssi < -65 && this.rssi >= -80) {
        this.quality = "fair";
      } else {
        this.quality = "poor";
      }
    }
  },
  watch: {
    rssi() {
      this.calculateQuality();
    }
  }
};
</script>

<style scoped>
.default {
  fill: white;
  stroke: rgb(145, 145, 145) !important;
}
.poor {
  fill: red !important;
}
.fair {
  fill: orange !important;
}
.good {
  fill: rgb(142, 223, 12) !important;
}
.excellent {
  fill: rgb(0, 163, 0) !important;
}
.line2.poor {
  fill: none;
  stroke: rgb(145, 145, 145);
}
.line3.poor,
.line3.fair {
  fill: none;
  stroke: rgb(145, 145, 145);
}
.line4.poor,
.line4.fair,
.line4.good {
  fill: none;
  stroke: rgb(145, 145, 145);
}
.wrapper {
  display: flex;
  flex-direction: row;
  width: 100px;
  font-size: 8px;
}
.description {
  flex: 1;
  padding-left: 5px;
  text-align: left;
  display: flex;
  line-height: 11px;
  flex-direction: column;
  align-items: baseline;
}
</style>
